module.exports = __webpack_public_path__ + "img/744.8567fd2b.jpg";